import * as core from '../../../../../../../core'

import { query } from './baseline-data-collection-framework-report-card.query'

export const RESOURCE = {
  payload: {
    alias: 'baseline-data-collection-framework.report-card',
    description:
      'Shows the Baseline Data Collection Framework for a given Affiliate',
    name: 'Baseline Data Collection Framework Report Card',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
